import React, { Fragment } from "react";
import { Modal } from "../../../components/modal/Modal";

const DetailsPlusModal = ({
  showDetailsPlusModal,
  onToggleDetailsPlusModal,
}: {
  showDetailsPlusModal: boolean;
  onToggleDetailsPlusModal: () => void;
}) => {
  return (
    <Modal
      modalNumber={5}
      isOpen={showDetailsPlusModal}
      onToggleModal={onToggleDetailsPlusModal}
      headerText="Nothelferkurse"
    >
      <div className="flex flex-col gap-8 mt-6">
        <div className="flex flex-col gap-4">
          <p className="font-semibold font-title text-dark-blue text-xl">
            Allgemein
          </p>
          <div className="grid grid-cols-3 max-lg:grid-cols-2 font-content text-md text-light-gray space-y-2">
            <div>
              <p className="font-semibold">Kursdauer</p>
              <p className="">10 Lektionen</p>
            </div>
            <div>
              <p className="font-semibold">Kosten</p>
              <p className="">Fr. 130.- (all inclusive)</p>
            </div>
            <div>
              <p className="font-semibold ">Mindestalter</p>
              <p className="">14 Jahre</p>
            </div>
            <div>
              <p className="font-semibold">Gültigkeit</p>
              <p className="">
                Der Nothelferausweis <br /> ist 6 Jahre gültig.
              </p>
            </div>
            <div>
              <p className="font-semibold">Teilnehmerzahl</p>
              <p className="">max. 12 Teilnehmer</p>
            </div>
            <div>
              <p className="font-semibold">Pausen</p>
              <p className="">
                Bei 2-Tages-Kursen gibt es auch eine Mittags-Pause.
              </p>
            </div>
          </div>
          <div className="font-content text-md text-light-gray">
            <p className="font-semibold">Notwendigkeit</p>
            <p className="font-content">
              Der Original Nothelferausweis ist bei der erstmaligen Einreichung
              des Gesuchs für die Erteilung eines Lernfahrausweises der Kat. A,
              A1 und B beizulegen.
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <p className="font-semibold font-title text-dark-blue text-xl">
            Kursinhalte
          </p>
          <div className="grid grid-cols-3 max-lg:grid-cols-2 font-content text-md text-light-gray space-x-1">
            <ul className="list-disc pl-4">
              <li>Selbstschutz</li>
              <li>Herzinfarkt und Schlaganfall erkennen</li>
              <li>Einsatz von Defibrillator</li>
            </ul>
            <ul className="list-disc pl-4 max-lg:hidden">
              <li>Unfallstelle absichern</li>
              <li>Notruf auslösen</li>
              <li>Gefahren erkennen</li>
            </ul>
            <ul className="list-disc pl-4 max-lg:hidden">
              <li>Druckverband</li>
              <li>Reanimation</li>
            </ul>
            <div className="lg:hidden">
              <ul className="list-disc pl-4">
                <li>Unfallstelle absichern</li>
                <li>Notruf auslösen</li>
                <li>Gefahren erkennen</li>
              </ul>
              <ul className="list-disc pl-4">
                <li>Druckverband</li>
                <li>Reanimation</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <p className="font-semibold font-title text-dark-blue text-xl">
            Nichterscheinen
          </p>
          <p className="font-content text-md text-light-gray">
            Auch in Folge Krankheit/Unfall ohne Arztzeugnis oder zu spätes
            Erscheinen am Kursort haben in jedem Fall die Verrechnung des ganzen
            Kursgeldes zur Folge. Bei einer Teilnehmerzahl von weniger als 4
            Personen behält sich die{" "}
            <a href="http://www.fahrschul-kurse.ch" className="text-blue-500">
              Fahrschul-Kurse.ch
            </a>{" "}
            das Recht vor den Kurs abzusagen!
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default DetailsPlusModal;
